// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;utf8,<svg xmlns=%27http://www.w3.org/2000/svg%27 width=%2714%27 height=%2714%27 viewBox=%270 0 24 24%27 fill=%27%23E5E7EB%27><path d=%27M7 10l5 5 5-5z%27/></svg>", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  color-scheme: dark;

  /* brand colors */
  --eaim-purple: #6c2bd9;
  --eaim-pink: #e34ab5;
  --magenta: #b31e8d;

  /* dark theme tokens */
  --bg: #2c2c2c; /* page background */
  --panel: #2f2f2f; /* cards, inputs, modal panels */
  --panel-elev: #0f141c; /* slightly deeper panel */
  --border: #2c3443; /* subtle borders on dark */
  --text: #e5e7eb; /* primary text */
  --muted: #a3a9b6; /* secondary text / placeholders */
  --white: #fff;
}

.mgmt-wrap {
  min-height: 100dvh;
  background: var(--bg);
  color: var(--text);
  font-family: "Manrope-Regular", system-ui, sans-serif;
}

/* Header */
.mgmt-header {
  position: relative;
  background: linear-gradient(
    135deg,
    var(--eaim-purple) 0%,
    var(--eaim-pink) 70%
  );
  color: #fff;
  padding: 16px 24px 25px;
  box-shadow: inset 0 -6px 0 rgba(0, 0, 0, 0.45);
  margin-bottom: 20px;
}
.brand-row {
  display: flex;
  align-items: center;
  gap: 12px;
}
.brand-logo {
  height: 56px;
  object-fit: contain;
}
.brand-fallback .brand-eaim {
  font-weight: 900;
  letter-spacing: 0.06em;
  font-size: 40px;
  line-height: 1;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.35);
}
.brand-fallback .brand-sub {
  opacity: 0.92;
  margin-top: 2px;
  font-size: 12px;
}

/* Main */
.mgmt-main {
  max-width: 1100px;
  margin: 0 auto;
  padding: 46px 20px 28px;
}

.mgmt-form {
  width: 100%;
}

.field label {
  display: block;
  font-size: 12px;
  margin-bottom: 6px;
  color: var(--muted);
}

.input {
  width: 100%;
  height: 40px;
  border-radius: 8px;
  border: 1px solid var(--border);
  padding: 0 12px;
  font-size: 16px;
  outline: none;
  background: var(--panel);
  color: var(--text);
  transition: box-shadow 0.15s ease, border-color 0.15s ease,
    background 0.15s ease;
  font-family: "Manrope-Regular", system-ui, sans-serif;
}
.input::placeholder {
  color: var(--muted);
}
.input:focus {
  border-color: #d67ac4;
  box-shadow: 0 0 0 4px rgba(227, 74, 181, 0.28);
}

.input-sm {
  height: 36px;
  width: 140px;
}

.action-col {
  display: flex;
  align-items: flex-end;
  justify-content: flex-start;
  padding-top: 18px;
}

.select {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  background-color: var(--panel);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 10px center;
  padding-right: 36px;
}

.btn {
  border: none;
  border-radius: 10px;
  padding: 10px 20px;
  font-size: 16px;
  font-weight: 600;
  color: #fff;
  background: var(--magenta);
  cursor: pointer;
  transition: transform 0.04s ease, filter 0.15s ease, box-shadow 0.15s ease;
  height: 40px;
  box-shadow: 0 8px 20px rgba(179, 30, 141, 0.22);
}
.btn:hover {
  filter: brightness(1.06);
}
.btn:active {
  transform: translateY(1px);
}
.btn:focus-visible {
  outline: none;
  box-shadow: 0 0 0 4px rgba(227, 74, 181, 0.3);
}

.section {
  margin-top: 26px;
}
.section-title {
  font-weight: 700;
  margin-bottom: 8px;
  color: #f2f3f5;
}
.inline-field {
  display: flex;
  align-items: center;
  gap: 10px;
}
.unit {
  color: var(--muted);
}

.grid-4 {
  display: grid;
  grid-template-columns: 1fr 1fr 2fr 120px;
  gap: 16px;
  align-items: end;
  grid-auto-flow: dense;
}

.ann-field {
  grid-column: 1 / span 3;
}

.action-col {
  display: flex;
  align-items: flex-end;
  justify-content: flex-start;
  align-self: end;
  padding-top: 0;
}

.textarea {
  min-height: 110px;
  padding-top: 8px;
  padding-bottom: 8px;
  resize: vertical;
  line-height: 1.4;
}

/* pin modal */

.modal-overlay {
  position: fixed;
  inset: 0;
  z-index: 9999;
  background: rgba(0, 0, 0, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(1.5px);
}

.pin-modal {
  width: min(520px, 92vw);
  background: var(--panel-elev);
  border-radius: 16px;
  box-shadow: 0 18px 60px rgba(0, 0, 0, 0.55);
  padding: 22px 22px 20px;
  border: 1px solid var(--border);
  text-align: center;
  color: var(--text);
}

.pin-head {
  display: flex;
  gap: 12px;
  align-items: center;
  justify-content: center;
  margin-bottom: 8px;
}
.pin-logo {
  height: 46px;
  object-fit: contain;
}
.pin-title {
  font-weight: 700;
  font-size: 18px;
  color: #f2f3f5;
}

.pin-inputs {
  display: flex;
  justify-content: center;
  gap: 12px;
  margin: 16px 0 6px;
}

.pin-box {
  width: 44px;
  height: 52px;
  text-align: center;
  font-size: 24px;
  font-weight: 700;
  border-radius: 10px;
  border: 1px solid var(--border);
  background: var(--panel);
  color: var(--text);
  outline: none;
  transition: box-shadow 0.15s ease, border-color 0.15s ease,
    background 0.15s ease;
}
.pin-box:focus {
  border-color: #d67ac4;
  box-shadow: 0 0 0 4px rgba(227, 74, 181, 0.28);
}

.pin-error {
  color: #ff6b6b;
  margin: 4px 0 8px;
  min-height: 20px;
}

.pin-actions {
  margin-top: 6px;
}
.pin-actions .btn {
  background: var(--magenta);
  color: #fff;
  padding: 10px 28px;
  border-radius: 10px;
  border: none;
  cursor: pointer;
  box-shadow: 0 10px 24px rgba(179, 30, 141, 0.24);
}
.pin-actions .btn:disabled {
  opacity: 0.85;
  cursor: not-allowed;
}

/* Cards */

.cards-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  gap: 14px;
  margin-top: 10px;
}

.card-announce {
  background: var(--panel);
  border: 1px solid var(--border);
  border-radius: 12px;
  padding: 12px 14px 14px;
  box-shadow: 0 10px 26px rgba(0, 0, 0, 0.32);
  position: relative;
  min-height: 120px;
  color: var(--text);
}

.card-dates {
  font-weight: 700;
  font-size: 14px;
  margin-bottom: 6px;
  display: flex;
  align-items: center;
  gap: 8px;
  color: #f2f3f5;
}

.chip {
  background: rgba(227, 74, 181, 0.16);
  color: #f4c5e6;
  border-radius: 999px;
  padding: 2px 8px;
  font-size: 12px;
  border: 1px solid rgba(227, 74, 181, 0.28);
}

.card-text {
  font-size: 14px;
  line-height: 1.45;
  white-space: pre-wrap;
  word-break: break-word;
  padding-right: 44px; /* room for action buttons */
  color: var(--text);
}

.card-actions {
  position: absolute;
  right: 10px;
  bottom: 10px;
  display: flex;
  gap: 8px;
}

.icon-btn {
  border: 1px solid var(--border);
  background: var(--panel-elev);
  color: #eaecef; /* icon color */
  border-radius: 8px;
  width: 34px;
  height: 34px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: transform 0.05s ease, box-shadow 0.15s ease, filter 0.15s ease,
    background 0.15s ease;
}
.icon-btn:hover {
  box-shadow: 0 0 0 4px rgba(227, 74, 181, 0.22);
  filter: brightness(1.02);
}
.icon-btn:active {
  transform: translateY(1px);
}

.ann-helper{
  margin-top: 6px;
  display: flex;
  justify-content: flex-end;
}

.char-counter{
  font-size: 12px;
  line-height: 1;
  color: #fff;
}

.char-counter.at-limit{ color: #b00020; }

/* Responsive */
@media (max-width: 900px) {
  .grid-4 {
    grid-template-columns: 1fr;
    align-items: stretch;
  }
  .ann-field {
    grid-column: 1 / -1;
  }
  .action-col {
    align-self: start;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/management.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;;EAElB,iBAAiB;EACjB,sBAAsB;EACtB,oBAAoB;EACpB,kBAAkB;;EAElB,sBAAsB;EACtB,aAAa,EAAE,oBAAoB;EACnC,gBAAgB,EAAE,gCAAgC;EAClD,qBAAqB,EAAE,0BAA0B;EACjD,iBAAiB,EAAE,2BAA2B;EAC9C,eAAe,EAAE,iBAAiB;EAClC,gBAAgB,EAAE,kCAAkC;EACpD,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,qDAAqD;AACvD;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB;;;;GAIC;EACD,WAAW;EACX,uBAAuB;EACvB,8CAA8C;EAC9C,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,cAAc;EACd,2CAA2C;AAC7C;AACA;EACE,aAAa;EACb,eAAe;EACf,eAAe;AACjB;;AAEA,SAAS;AACT;EACE,iBAAiB;EACjB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;EAC/B,eAAe;EACf,eAAe;EACf,aAAa;EACb,wBAAwB;EACxB,kBAAkB;EAClB;yBACuB;EACvB,qDAAqD;AACvD;AACA;EACE,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;EACrB,8BAA8B;EAC9B,yDAAqL;EACrL,4BAA4B;EAC5B,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,0BAA0B;EAC1B,eAAe;EACf,0EAA0E;EAC1E,YAAY;EACZ,+CAA+C;AACjD;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,wCAAwC;EACxC,SAAS;EACT,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,2BAA2B;EAC3B,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,cAAc;;AAEd;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,mBAAmB;EACnB,2CAA2C;EAC3C,uBAAuB;EACvB,+BAA+B;EAC/B,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,+BAA+B;EAC/B,wBAAwB;EACxB,kBAAkB;EAClB,aAAa;EACb;yBACuB;AACzB;AACA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;AACA;EACE,0BAA0B;EAC1B,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gDAAgD;AAClD;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA,UAAU;;AAEV;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,+BAA+B;EAC/B,mBAAmB;EACnB,uBAAuB;EACvB,2CAA2C;EAC3C,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;EACtB,mBAAmB,EAAE,4BAA4B;EACjD,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,+BAA+B;EAC/B,6BAA6B;EAC7B,cAAc,EAAE,eAAe;EAC/B,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf;yBACuB;AACzB;AACA;EACE,8CAA8C;EAC9C,wBAAwB;AAC1B;AACA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,WAAW;AACb;;AAEA,wBAAwB,cAAc,EAAE;;AAExC,eAAe;AACf;EACE;IACE,0BAA0B;IAC1B,oBAAoB;EACtB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;AACF","sourcesContent":[":root {\n  color-scheme: dark;\n\n  /* brand colors */\n  --eaim-purple: #6c2bd9;\n  --eaim-pink: #e34ab5;\n  --magenta: #b31e8d;\n\n  /* dark theme tokens */\n  --bg: #2c2c2c; /* page background */\n  --panel: #2f2f2f; /* cards, inputs, modal panels */\n  --panel-elev: #0f141c; /* slightly deeper panel */\n  --border: #2c3443; /* subtle borders on dark */\n  --text: #e5e7eb; /* primary text */\n  --muted: #a3a9b6; /* secondary text / placeholders */\n  --white: #fff;\n}\n\n.mgmt-wrap {\n  min-height: 100dvh;\n  background: var(--bg);\n  color: var(--text);\n  font-family: \"Manrope-Regular\", system-ui, sans-serif;\n}\n\n/* Header */\n.mgmt-header {\n  position: relative;\n  background: linear-gradient(\n    135deg,\n    var(--eaim-purple) 0%,\n    var(--eaim-pink) 70%\n  );\n  color: #fff;\n  padding: 16px 24px 25px;\n  box-shadow: inset 0 -6px 0 rgba(0, 0, 0, 0.45);\n  margin-bottom: 20px;\n}\n.brand-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n.brand-logo {\n  height: 56px;\n  object-fit: contain;\n}\n.brand-fallback .brand-eaim {\n  font-weight: 900;\n  letter-spacing: 0.06em;\n  font-size: 40px;\n  line-height: 1;\n  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.35);\n}\n.brand-fallback .brand-sub {\n  opacity: 0.92;\n  margin-top: 2px;\n  font-size: 12px;\n}\n\n/* Main */\n.mgmt-main {\n  max-width: 1100px;\n  margin: 0 auto;\n  padding: 46px 20px 28px;\n}\n\n.mgmt-form {\n  width: 100%;\n}\n\n.field label {\n  display: block;\n  font-size: 12px;\n  margin-bottom: 6px;\n  color: var(--muted);\n}\n\n.input {\n  width: 100%;\n  height: 40px;\n  border-radius: 8px;\n  border: 1px solid var(--border);\n  padding: 0 12px;\n  font-size: 16px;\n  outline: none;\n  background: var(--panel);\n  color: var(--text);\n  transition: box-shadow 0.15s ease, border-color 0.15s ease,\n    background 0.15s ease;\n  font-family: \"Manrope-Regular\", system-ui, sans-serif;\n}\n.input::placeholder {\n  color: var(--muted);\n}\n.input:focus {\n  border-color: #d67ac4;\n  box-shadow: 0 0 0 4px rgba(227, 74, 181, 0.28);\n}\n\n.input-sm {\n  height: 36px;\n  width: 140px;\n}\n\n.action-col {\n  display: flex;\n  align-items: flex-end;\n  justify-content: flex-start;\n  padding-top: 18px;\n}\n\n.select {\n  appearance: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  background-color: var(--panel);\n  background-image: url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='14' height='14' viewBox='0 0 24 24' fill='%23E5E7EB'><path d='M7 10l5 5 5-5z'/></svg>\");\n  background-repeat: no-repeat;\n  background-position: right 10px center;\n  padding-right: 36px;\n}\n\n.btn {\n  border: none;\n  border-radius: 10px;\n  padding: 10px 20px;\n  font-size: 16px;\n  font-weight: 600;\n  color: #fff;\n  background: var(--magenta);\n  cursor: pointer;\n  transition: transform 0.04s ease, filter 0.15s ease, box-shadow 0.15s ease;\n  height: 40px;\n  box-shadow: 0 8px 20px rgba(179, 30, 141, 0.22);\n}\n.btn:hover {\n  filter: brightness(1.06);\n}\n.btn:active {\n  transform: translateY(1px);\n}\n.btn:focus-visible {\n  outline: none;\n  box-shadow: 0 0 0 4px rgba(227, 74, 181, 0.3);\n}\n\n.section {\n  margin-top: 26px;\n}\n.section-title {\n  font-weight: 700;\n  margin-bottom: 8px;\n  color: #f2f3f5;\n}\n.inline-field {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n.unit {\n  color: var(--muted);\n}\n\n.grid-4 {\n  display: grid;\n  grid-template-columns: 1fr 1fr 2fr 120px;\n  gap: 16px;\n  align-items: end;\n  grid-auto-flow: dense;\n}\n\n.ann-field {\n  grid-column: 1 / span 3;\n}\n\n.action-col {\n  display: flex;\n  align-items: flex-end;\n  justify-content: flex-start;\n  align-self: end;\n  padding-top: 0;\n}\n\n.textarea {\n  min-height: 110px;\n  padding-top: 8px;\n  padding-bottom: 8px;\n  resize: vertical;\n  line-height: 1.4;\n}\n\n/* pin modal */\n\n.modal-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 9999;\n  background: rgba(0, 0, 0, 0.55);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  backdrop-filter: blur(1.5px);\n}\n\n.pin-modal {\n  width: min(520px, 92vw);\n  background: var(--panel-elev);\n  border-radius: 16px;\n  box-shadow: 0 18px 60px rgba(0, 0, 0, 0.55);\n  padding: 22px 22px 20px;\n  border: 1px solid var(--border);\n  text-align: center;\n  color: var(--text);\n}\n\n.pin-head {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 8px;\n}\n.pin-logo {\n  height: 46px;\n  object-fit: contain;\n}\n.pin-title {\n  font-weight: 700;\n  font-size: 18px;\n  color: #f2f3f5;\n}\n\n.pin-inputs {\n  display: flex;\n  justify-content: center;\n  gap: 12px;\n  margin: 16px 0 6px;\n}\n\n.pin-box {\n  width: 44px;\n  height: 52px;\n  text-align: center;\n  font-size: 24px;\n  font-weight: 700;\n  border-radius: 10px;\n  border: 1px solid var(--border);\n  background: var(--panel);\n  color: var(--text);\n  outline: none;\n  transition: box-shadow 0.15s ease, border-color 0.15s ease,\n    background 0.15s ease;\n}\n.pin-box:focus {\n  border-color: #d67ac4;\n  box-shadow: 0 0 0 4px rgba(227, 74, 181, 0.28);\n}\n\n.pin-error {\n  color: #ff6b6b;\n  margin: 4px 0 8px;\n  min-height: 20px;\n}\n\n.pin-actions {\n  margin-top: 6px;\n}\n.pin-actions .btn {\n  background: var(--magenta);\n  color: #fff;\n  padding: 10px 28px;\n  border-radius: 10px;\n  border: none;\n  cursor: pointer;\n  box-shadow: 0 10px 24px rgba(179, 30, 141, 0.24);\n}\n.pin-actions .btn:disabled {\n  opacity: 0.85;\n  cursor: not-allowed;\n}\n\n/* Cards */\n\n.cards-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));\n  gap: 14px;\n  margin-top: 10px;\n}\n\n.card-announce {\n  background: var(--panel);\n  border: 1px solid var(--border);\n  border-radius: 12px;\n  padding: 12px 14px 14px;\n  box-shadow: 0 10px 26px rgba(0, 0, 0, 0.32);\n  position: relative;\n  min-height: 120px;\n  color: var(--text);\n}\n\n.card-dates {\n  font-weight: 700;\n  font-size: 14px;\n  margin-bottom: 6px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  color: #f2f3f5;\n}\n\n.chip {\n  background: rgba(227, 74, 181, 0.16);\n  color: #f4c5e6;\n  border-radius: 999px;\n  padding: 2px 8px;\n  font-size: 12px;\n  border: 1px solid rgba(227, 74, 181, 0.28);\n}\n\n.card-text {\n  font-size: 14px;\n  line-height: 1.45;\n  white-space: pre-wrap;\n  word-break: break-word;\n  padding-right: 44px; /* room for action buttons */\n  color: var(--text);\n}\n\n.card-actions {\n  position: absolute;\n  right: 10px;\n  bottom: 10px;\n  display: flex;\n  gap: 8px;\n}\n\n.icon-btn {\n  border: 1px solid var(--border);\n  background: var(--panel-elev);\n  color: #eaecef; /* icon color */\n  border-radius: 8px;\n  width: 34px;\n  height: 34px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: transform 0.05s ease, box-shadow 0.15s ease, filter 0.15s ease,\n    background 0.15s ease;\n}\n.icon-btn:hover {\n  box-shadow: 0 0 0 4px rgba(227, 74, 181, 0.22);\n  filter: brightness(1.02);\n}\n.icon-btn:active {\n  transform: translateY(1px);\n}\n\n.ann-helper{\n  margin-top: 6px;\n  display: flex;\n  justify-content: flex-end;\n}\n\n.char-counter{\n  font-size: 12px;\n  line-height: 1;\n  color: #fff;\n}\n\n.char-counter.at-limit{ color: #b00020; }\n\n/* Responsive */\n@media (max-width: 900px) {\n  .grid-4 {\n    grid-template-columns: 1fr;\n    align-items: stretch;\n  }\n  .ann-field {\n    grid-column: 1 / -1;\n  }\n  .action-col {\n    align-self: start;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
